module.exports = __webpack_public_path__ + "img/info_blue.659f70b8.svg";